import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import batteryEngine from '../../../../../Widgets/DataPainterWidget/BatteryWidget/BatteryEngine';
import { CMD_BAT_SEQ_REGISTRY_KEY, META_TYPE, META_VER } from './batSeqCommandRegisteryType';

/**
 * Registers /batseq <rk> — opens/refocuses the sequence editor of that battery (multi-instance, target=rk).
 * params is a getter so the rk dropdown reflects BatteryCache at typing time.
 */
export function registerBatSeqCommand() {
    commandEngine.register('/batseq', {
        hint: '<rk> — edit battery sequences, e.g. /batseq HOA1NAN9N363820',
        get params() {
            return [
                {
                    name: 'rk',
                    options: batteryEngine.getAll().map((b) => ({ label: `${b.name} (${b.rk})`, value: b.rk })),
                },
            ];
        },
        handler: (params) => {
            const [rk] = params;
            if (!rk) return;

            cardPainterManager.openCard(CMD_BAT_SEQ_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: rk });
        },
    });
}
